import { createSelector } from "@reduxjs/toolkit";

export const selectEditWatchwordsState = (state) => state.watchwords.edit;

export const selectIsDirty = createSelector(
  [selectEditWatchwordsState],
  (edit) => Boolean(edit.isDirty)
);

export const selectIsEditing = createSelector(
  [selectEditWatchwordsState],
  (edit) => Boolean(edit.isEditing)
);

export const selectShowReplaceWithPanel = createSelector(
  [selectEditWatchwordsState],
  (edit) => Boolean(edit.showReplaceWithPanel)
);

export const selectEditWatchwordsData = createSelector(
  [selectEditWatchwordsState],
  (edit) => edit.data
);

export const selectWatchwordsListDescription = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.description || ""
);

export const selectWatchwordsListCategories = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.categories || []
);

export const selectWatchwordsListTypes = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.types || []
);

export const selectIsListDefault = createSelector(
  [selectEditWatchwordsData],
  (data) => Boolean(data?.default)
);

export const selectWatchwordsListName = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.name
);

export const selectWatchwordsListId = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.id
);

export const selectLockedBy = createSelector(
  [selectEditWatchwordsData],
  (data) => data?.lockedBy
);

export const selectIsLockedByOtherUser = createSelector(
  [selectEditWatchwordsData],
  (data) => Boolean(data?.lockedByAnotherUser)
);

export const selectWatchwordsOwner = createSelector(
  [selectEditWatchwordsData],
  (data) => {
    const { createdBy = "Unknown", createdOn } = data || {};

    return [createdBy === "Unknown" ? "System" : createdBy, createdOn];
  }
);

export const selectWatchwordsLastUpdated = createSelector(
  [selectEditWatchwordsData],
  (data) => {
    const { updatedBy, updatedOn } = data || {};
    return [updatedBy, updatedOn];
  }
);
